define('bizzabo/models/SyncedModel',['backbone', 'backbone-validation', 'bizzabo/models/SyncedCollection'], function(Backbone, BackboneValidation, SyncedCollection) {

    var SyncedModel = Backbone.Model.extend({

        wasEdited : false, // a form view exists/existed on this model
        isBeingEdited : false, // a form view exists on the model now
        wasChangedFromForm : false, // a form view changed at least one attribute of this model
        isSynced : false, // if true, the model and any synced children do not differ from server

        toJSON : function() {
            var originalToJson = Backbone.Model.prototype.toJSON.call(this, arguments);
            originalToJson['client-id'] = this.cid;
            var res = {};
            _.each(_.keys(originalToJson), function(key) {
                var attr = originalToJson[key];
                if (_.isObject(attr) && _.isFunction(attr.toJSON)) {
                    res[key] = attr.toJSON();
                } else {
                    res[key] = attr;
                }
            });
            return res;
        },

        isBrandNew : function() {
            return !(this.wasEdited || this.isSynced || this.isBeingEdited);
        },

        setFlagsAfterSync : function() {
            this.isSynced = true;
            this.wasChangedFromForm = false;
            this.forceFirstFetch = false;

            this.operateOnAllSyncedChildren(function(attr) {
                attr.setFlagsAfterSync();
            });
        },

        hasUnsavedData : function() {
            var childrensFlag = this.operateOnAllSyncedChildren(function(attr) {
                return attr.hasUnsavedData();
            });
            if (this.isNew()) {
                return this.wasChangedFromForm || childrensFlag;
            } else {
                var wasFetchedAndNotSynced = (!this.isSynced && !this.shouldFetch);
                return wasFetchedAndNotSynced || childrensFlag;
            }
        },

        assimilateJson : function(jsonModel) {
            var setKeys = {};
            for (var key in jsonModel) {
                var thisAttr = this.get(key);
                var jsonValue = jsonModel[key];
                if (thisAttr instanceof SyncedModel || thisAttr instanceof SyncedCollection) {
                    thisAttr.assimilateJson(jsonValue);
                } else {
                    setKeys[key] = jsonValue;
                    if (key == 'client-id') {
                        this.isSynced = true;
                        this.wasEdited = true; // it was imported, so we'll consider it as edited
                        this.cid = jsonValue;
                    }
                }
            }

            this.set(setKeys, {
                silent : false
            });

            return this;
        },

        operateOnAllSyncedChildren : function(fn) { // NOTICE only one level (not recursive)
            for (var key in this.attributes) {
                var thisAttr = this.get(key);
                if (thisAttr instanceof SyncedModel || thisAttr instanceof SyncedCollection) {
                    var res = fn(thisAttr);
                    if (res) {
                        return res;
                    }
                }
            }
        },

        onChildSyncedCollectionsOrModels : function(event, callback, context) {
            this.operateOnAllSyncedChildren(function(attr) {
                attr.on(event, callback, context);
            });
        },

        offChildSyncedCollectionsOrModels : function(event, callback, context) {
            this.operateOnAllSyncedChildren(function(attr) {
                attr.off(event, callback, context);
            });
        },

        /**
         * @param otherModel the other model
         * @return {Boolean} false by default
         */
        equalsByIdOrCid : function(otherModel) {
            var thisId = this.get('id');
            var thisCid = this.cid;
            var otherId = otherModel.get('id');
            var otherCid = otherModel.cid;

            if ((!_.isUndefined(thisId)) && (!_.isUndefined(otherId))) {
                return thisId == otherId;
            }
            if ((!_.isUndefined(thisCid)) && (!_.isUndefined(otherCid))) {
                return thisCid == otherCid;
            }
            return false;
        }
    });

    return SyncedModel;

});
